const STATUSES = {
	SUCCESS_STATUS: 'successful',
	ERROR_STATUS: 'error',
	CANCELED_STATUS: 'canceled',
	STARTED_STATUS: 'started',
	DEFAULT_STATUS: 'default',
};

const statusClassMapping = {
	[STATUSES.SUCCESS_STATUS]: 'green_status',
	[STATUSES.ERROR_STATUS]: 'red_status',
	[STATUSES.CANCELED_STATUS]: 'orange_status',
	[STATUSES.STARTED_STATUS]: 'blue_status',
	[STATUSES.DEFAULT_STATUS]: 'grey_status',
};

const STARTED_COLOR = '#5B8AF7';
const statusToColorMapping = {
	done: '#3CC5AA',
	error: '#FC337A',
	waiting: '#FAAA5A',
	canceled: '#5A677D',
	started: STARTED_COLOR,
	pending: STARTED_COLOR,
	resumed: STARTED_COLOR,
	throttled: STARTED_COLOR,
};

const stepIconClassMapping = {
	[STATUSES.SUCCESS_STATUS]: 'step-check',
	[STATUSES.ERROR_STATUS]: 'step-failed',
	[STATUSES.CANCELED_STATUS]: 'step-canceled',
	[STATUSES.STARTED_STATUS]: 'step-started',
	[STATUSES.DEFAULT_STATUS]: 'step-waiting',
};

const getStatusText = (status) => (status == 'done' ? STATUSES.SUCCESS_STATUS : status);

const getFlowStatusClass = (statusText) => statusClassMapping[statusText] || statusClassMapping[STATUSES.DEFAULT_STATUS];

const getTriggeringUserText = (user) => (user.first_name ? `${user.first_name} ${user.last_name}` : '');

const getStepIconClass = (status) => {
	const statusText = getStatusText(status);
	return stepIconClassMapping[statusText] || stepIconClassMapping[STATUSES.DEFAULT_STATUS];
};

module.exports = {
	getStatusText,
	getFlowStatusClass,
	getTriggeringUserText,
	getStepIconClass,
	STATUSES,
	statusToColorMapping,
};
